export const FF_DASHBOARD_NOTIFICATION_SETTINGS = 'dashboard-notification-settings';
export const FF_DASHBOARD_CUSTOMER_MANAGEMENT = 'dashboard-customer-management';
